import { render, staticRenderFns } from "./StoreDegreeStudent_1.vue?vue&type=template&id=28e564bd&scoped=true"
import script from "./StoreDegreeStudent_1.vue?vue&type=script&lang=js"
export * from "./StoreDegreeStudent_1.vue?vue&type=script&lang=js"
import style0 from "./StoreDegreeStudent_1.vue?vue&type=style&index=0&id=28e564bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e564bd",
  null
  
)

export default component.exports